const _locale = JSON.parse(localStorage.getItem('locale'));

export default {
	state: {
		error: null,
		loading: false,
		locale: _locale ? _locale : 'en-US',
		snackbar: { on: false, color: "white", text: "", timeout: 1500 }
	}, 
	mutations: {
		setLoading (state, payload) {
			state.loading = payload
		},
		setError (state, payload) {
			state.error = payload
		},
		setLocale (state, payload) {
			state.locale = payload;
		},		
		clearError (state) {
			state.error = null
		},
		setSnackbar(state, payload) {
			state.snackbar = payload;
		},
	},
	actions: {
		setLoading ({commit}, payload) {
			commit('clearError')
			commit('setLoading', payload)
		},
		setError ({commit}, payload) {
			commit('clearError')
			commit('setError', payload)
		},
		setLocale({commit}, payload) {
			commit('clearError')
			commit('setLocale', payload)
		},
		clearError ({commit}) {
			commit('clearError')
		},
		showSnackbar({ commit }, payload) {
			commit('clearError')
			commit('setSnackbar', payload)
		},
	},
	getters: {
		loading (state) {
			return state.loading;
		},
		error (state) {
			return state.error;
		},
		locale (state) {
			return state.locale;
		},
		snackbar(state) {
			return state.snackbar;
		}
	}
}